import { Stack, Alert, IconButton, Typography} from "@mui/material";
import { useState } from "react";
import Address from "../Inputs/Address";
import { LoadingButton } from "@mui/lab";
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from "react-router-dom";
import BackIcon from '@mui/icons-material/ArrowBack';
import Invoice from "./Invoice";
import API from "../../services/API/API";
import Detail from "./Detail";

export default function Order({order, onChange, readOnly}){

    const navigate = useNavigate()

    const [status, setStatus] = useState('ready')

    const statusIs = str => str === status

    const handleSubmit = e => {
        e.preventDefault()

        setStatus('submit')

        API.put(`/orders/${order?.uuid}/pay`, order)
            .then(r => {
                window.location.href = r?.data?.paymentUrl;
            })
            .catch(e => setStatus('error'))
        
    }

    const locked = readOnly && order?.completed

    
    return order && <Stack spacing={3} sx={{maxWidth: 800}}>

        <Stack direction='row' alignItems='center' spacing={1}>

            <IconButton onClick={() => navigate(-1)}>
                <BackIcon />
            </IconButton>

            <Typography variant='h2'>Récapitulatif de la commande</Typography>

        </Stack>


        <Detail order={order} />


        {order.completed && <>

            <Alert severity='success'>Commande {order.status?.title.toLowerCase()}</Alert>

            {order.paid && <Invoice order={order}/>}

        </>}


        {!locked && 
                    
            <form onSubmit={handleSubmit}>

                <Stack direction='column' spacing={3}>

                    <Typography variant='h5'>Confirmez vos coordonnées :</Typography>

                    <Address
                        value={order.user}
                        onChange={value => onChange({...order, user: value})}
                        required
                    />

                    <LoadingButton
                        type='submit'
                        variant='contained'
                        startIcon={order.free ? <CheckIcon /> : <LockIcon />}
                        loading={statusIs('submit')}
                        size='large'
                        sx={{alignSelf: 'end'}}
                    >
                        {order.amount > 0 ? 
                            `Payer ${order.total.toLocaleString()}€` : 
                            'Confirmer'
                        }
                    </LoadingButton>
                                
                </Stack>

            </form>
        }

    </Stack>
}